import { TENANT_GOVERNANCE_PERMISSION_GROUPS } from "../../constants/tenantGovernancePermissions";

export const TENANT_ADMIN_MODULES = [
  {
    key: "module_fire_safety_logbook",
    slug: "installaties-logboek",
    title: "Installaties & logboeken",
    description: "Digitale logboeken en brandveiligheidsmodule voor installaties en compliance.",
    permissionsAny: TENANT_GOVERNANCE_PERMISSION_GROUPS.modulesView,
  },
  {
    key: "module_customer_portal",
    slug: "klantportaal",
    title: "Klantportaal",
    description: "Toegang en publicatie naar het klantportaal binnen de tenant.",
    permissionsAny: TENANT_GOVERNANCE_PERMISSION_GROUPS.modulesView,
  },
  {
    key: "module_supplier_templates",
    slug: "supplier-templates",
    title: "Supplier templatebibliotheek",
    description: "Template-import en leveranciersbibliotheek voor inkoop en standaardisatie.",
    permissionsAny: TENANT_GOVERNANCE_PERMISSION_GROUPS.modulesView,
  },
  {
    key: "module_zzp_mode",
    slug: "zzp-modus",
    title: "ZZP-modus",
    description: "Flexibele werkbonflow voor kleine teams en zelfstandige inzet.",
    permissionsAny: TENANT_GOVERNANCE_PERMISSION_GROUPS.modulesView,
  },
];

export function getModuleDetailPath(slug) {
  return `/tenant-admin/modules/${slug}`;
}

export function findModuleBySlug(slug) {
  const value = String(slug || "").trim().toLowerCase();
  return TENANT_ADMIN_MODULES.find((module) => module.slug === value) || null;
}
